import { styled } from 'styled-components';
import { IGlobaVariables } from '../../../components/Layout/styles';
import { IContent } from '../../../types/elements';
import { ICookiesPopup, defaultParams } from './params';
import { config } from 'process';

const Styles = styled.div<{
  theme?: IGlobaVariables;
  config: IContent;
  cookies?: ICookiesPopup;
}>`
  .cookies-popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-end;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1000;

    &-wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 15px 0;
      background: ${({ cookies: cookies }) => (cookies ? cookies?.backgroundColor : '#fff')};
    }

    &-content {
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 30px;
      margin-bottom: 15px;

      &-description {
        p {
          color: ${({ cookies }) => (cookies ? cookies?.color : '#000')};
          font-family: ${({ config: { text } }) => text.fontFamily};
          font-weight: ${({ config: { text } }) => text.fontWeight};
          font-size: ${({ config: { text } }) => text.fontSize};
          line-height: ${({ config: { text } }) => text.lineHeight};
          margin: ${({ config: { text } }) => text.margin};
          &.subtitle {
            font-family: ${({ config: { h3 } }) => h3.fontFamily};
            font-weight: ${({ config: { h3 } }) => h3.fontWeight};
            font-size: ${({ config: { h3 } }) => h3.fontSize};
            line-height: ${({ config: { h3 } }) => h3.lineHeight};
            margin: ${({ config: { h3 } }) => h3.margin};
          }

          a {
            color: ${({ cookies }) => (cookies ? cookies?.group_link.color : '#265165')};
            text-decoration: none;
            font-style: ${({ config: { link } }) => link.fontStyle};
            transition: color 0.3s ease-in-out;

            &:hover {
              color: ${({ cookies }) => (cookies ? cookies?.group_link.color : '#265165')};
              text-decoration: underline;
            }
          }

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }

    &-buttons {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-end;
      gap: 12px;

      &-button {
        font-size: 14px;
        outline: none;
        color: ${({ cookies }) => (cookies ? cookies?.group_button.color : '#265165')};
        padding: 10px 20px;
        height: 40px;
        border-radius: 2px;
        cursor: pointer;
        transition: 0.2s all ease-in;
        border: none;
        background: transparent;

        &.config:hover {
          text-decoration: underline;
        }

        &.reject {
          border: 1px solid ${({ cookies }) => (cookies ? cookies?.group_button.color : '#265165')};
          background: ${({ cookies }) => (cookies ? cookies?.group_button.backgroundColor : '#fff')};
          &:hover {
            color: ${({ cookies }) => (cookies ? cookies?.group_button.hover_color : '#fff')};
            background: ${({ cookies }) => (cookies ? cookies?.group_button.hover_backgroundColor : '#e9602d')};
            border: 1px solid transparent;
            text-decoration: none;
          }
        }

        &.accept {
          color: ${({ cookies }) => (cookies ? cookies?.group_button.hover_color : '#fff')};
          background: ${({ cookies }) => (cookies ? cookies?.group_button.hover_backgroundColor : '#e9602d')};
          border: 1px solid ${({ cookies }) => (cookies ? cookies?.group_button.hover_backgroundColor : '#e9602d')};
          &:hover {
            box-shadow: 0 0 5px ${({ cookies }) => (cookies ? cookies?.group_button.color : '#000')};
          }
        }
      }
    }
  }
  @media (min-width: ${({ theme }) => theme.breakpoint.sm}) {
    .cookies-popup {
      &-wrapper {
        padding: 30px 0;
      }
      &-content {
        flex-direction: row;
        margin-bottom: 30px;
      }
      &-buttons {
        gap: 15px;
      }
    }
  }
`;

export default Styles;
